export const loginTour = {
  key: "login",
  version: 2,
  getSteps: (t) => [
    {
      target: '[data-tour="login-language"]',
      content: t("Tour_Login_Language"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="login-tabs"]',
      content: t("Tour_Login_Tabs"),
      placement: "bottom",
    },
    {
      target: '[data-tour="login-google"]',
      content: t("Tour_Login_Google"),
      placement: "bottom",
    },
    {
      target: '[data-tour="login-email"]',
      content: t("Tour_Login_Email"),
      placement: "bottom",
    },
    {
      target: '[data-tour="login-phone"]',
      content: t("Tour_Login_Phone"),
      placement: "bottom",
    },
    {
      target: '[data-tour="login-password"]',
      content: t("Tour_Login_Password"),
      placement: "bottom",
    },
    {
      target: '[data-tour="login-forget"]',
      content: t("Tour_Login_Forget"),
      placement: "top",
    },
    {
      target: '[data-tour="login-find-contact"]',
      content: t("Tour_Login_FindContact"),
      placement: "top",
    },
    {
      target: '[data-tour="login-otp"]',
      content: t("Tour_Login_OTP"),
      placement: "bottom",
    },
    {
      target: '[data-tour="login-submit"]',
      content: t("Tour_Login_Submit"),
      placement: "top",
    },
    {
      target: '[data-tour="login-support"]',
      content: t("Tour_Login_Support"),
      placement: "left",
    },
    {
      target: '[data-tour="help-button"]',
      content: t("Tour_HelpButtonHint"),
      placement: "bottom",
    },
  ],
};
